const PLAYABLE_VIDEO_MIME_TYPES = new Set(['video/mp4', 'video/ogg', 'video/webm']);
const LAST_C0_CONTROL_CODE_POINT = 0x1f;
const DELETE_CONTROL_CODE_POINT = 0x7f;

function hasUrlControlCharacter(src: string): boolean {
  return src.split('').some((character) => {
    const codePoint = character.charCodeAt(0);
    return codePoint <= LAST_C0_CONTROL_CODE_POINT || codePoint === DELETE_CONTROL_CODE_POINT;
  });
}

export function isPlayableVideoMimeType(mimeType: unknown): mimeType is string {
  return typeof mimeType === 'string' && PLAYABLE_VIDEO_MIME_TYPES.has(mimeType.trim().toLowerCase());
}

/** Video assets use their original delivery URL; image/Imgix rewriting is intentionally excluded. */
export function isSafeVideoSrc(src: unknown): src is string {
  if (typeof src !== 'string') return false;
  if (src.length === 0 || src !== src.trim() || src.includes('\\') || hasUrlControlCharacter(src)) {
    return false;
  }
  if (src.startsWith('/') && !src.startsWith('//')) return true;

  try {
    const parsed = new URL(src);
    return parsed.protocol === 'https:' && !parsed.username && !parsed.password;
  } catch {
    return false;
  }
}
